import {useEffect, useRef, useState} from 'react';
import './style.css';
import api from 'services/api';
import apibasic from 'services/apibasic';
import {getcodCidade} from 'functions/gettabconfig';
import config from 'config';
import NavbarVisitante from 'components/navbarvisitante';
import StoreLinks from 'components/storelinks';
import CarrosselCampanhas from 'components/carrosselCampanha';
import CarrosselParticipantes from 'components/carrosselParticipantes';
import CarrosselContemplados from 'components/carrosselContemplados';
import CarrosselNoticias from 'components/carrosselNoticias';
import CarrosselPromocoes from 'components/CarroselPromocoes';
import LoginModal from './modal';

function Login() {
    const initializedRef = useRef(false);

    const [isOpen, setIsOpen] = useState(false);

    const openLoginModal = () => setIsOpen(true);

    const closeLoginModal = () => {
        setIsOpen(false);
    };
    
    const loginVisitante = async () => {
        try {
            const response = await apibasic.post('/v1/login', {
            email: 'visitante@actusoficial.com.br',
            senha: '3501bf4b3c44b07c6d44d00a03beb871'
            });
            localStorage.setItem('eamigaconfig', JSON.stringify(response.data));
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    };

    const [lcompanha, setLCampanha] = useState([]);
    const [lparticipante, setLParticipante] = useState([]);
    const [lcontemplado, setLContemplado] = useState([]);
    const [lnoticias, setLNoticias] = useState([]);
    const [lpromocoes, setlPromocoes] = useState([]);
    const [pnoticias, setPNotocias] = useState('N');
    const [ppromocoes, setPPromocoes] = useState('N');


    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

     useEffect(() => {
        if (initializedRef.current) {
            return;
        }
        initializedRef.current = true;

        const fetchData = async () => {
            const loginOk = await loginVisitante();
            if (!loginOk) {
                return;
            }

            const codCidade = getcodCidade();

            // Busca Parametros
            api.get(`${config.PARAMETROS}/NOTICIAS`)
                .then(response => {
                    const valorNoticias = response.data['valor'];
                    setPNotocias(valorNoticias);
                    
                // Busca Noticias apenas se parametro = 'S'
                if (valorNoticias === 'S') {
                    api.get(`${config.NOTICIAS}?cod_cidade=${codCidade}`)
                        .then(response => {
                            setLNoticias(response.data);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
            api.get(`${config.PARAMETROS}/PROMOCOES`)
                .then(response => {
                    const valorPromocoes = response.data['valor'];
                setPPromocoes(valorPromocoes);
                
                // Busca Promocoes apenas se parametro = 'S'
                if (valorPromocoes === 'S') {
                    api.get(`${config.PROMOCOES}?cod_cidade=${codCidade}`)
                        .then(response => {
                            setlPromocoes(response.data);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            }) 
            .catch(error => {
                console.log(error);
            });           

            // Busca Campanhas
            api.get(`${config.CAMPANHAS}?cod_cidade=${codCidade}`)
                .then(response => {
                    setLCampanha(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
            // Busca Partificantes
            api.get(`${config.ESTABELECIMENTOS}?cod_cidade=${codCidade}`)
                .then(response => {
                    setLParticipante(shuffleArray(response.data));
                })
                .catch(error => {
                    console.log(error);
                });
            // Busca Contemplados
            api.get(`${config.CONTEMPLADOS}?cod_cidade=${codCidade}`)
                .then(response => {
                    setLContemplado(response.data);
                })
                .catch(error => {
                    console.log(error);
                });                
        };
        fetchData();
    }, [])

    return <>
        <NavbarVisitante login={openLoginModal} />
        <LoginModal
            isOpen={isOpen}
            onRequestClose={closeLoginModal}
        />
        <div className="container landing-page-container mt-4">
            <CarrosselCampanhas
                lcompanha={lcompanha}
            />
            <div className="mt-4">
                <CarrosselParticipantes
                    lparticipante={lparticipante}
                />
            </div>
            <div className="mt-4">
                <CarrosselContemplados
                    lcontemplado={lcontemplado}
                />
            </div>

            {pnoticias === 'S' && <div className="mt-4">
                <CarrosselNoticias
                    lnoticias={lnoticias}
                />
            </div>}
            {ppromocoes === 'S' && <div className="mt-4">
                <CarrosselPromocoes
                    lpromocoes={lpromocoes}
                />
            </div>}
            <div className="mt-5 text-center">
                <StoreLinks className="mt-3" />
            </div>
            <div className="mb-5 pb-5"></div>
        </div>
    </>
}

export default Login;